// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3iZjY","search":"Settings_search__20m2l","filter":"Settings_filter__2FrNT"};